function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 18 18"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M6.575 7.5a.575.575 0 01-1.15 0v-.925H4.5a.575.575 0 010-1.15h.925V4.5a.575.575 0 111.15 0v.925H7.5a.575.575 0 110 1.15h-.925V7.5zm7.5 4.688a.575.575 0 00-.575-.576h-3a.575.575 0 100 1.15h3a.575.575 0 00.575-.575z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeWidth: "1.15",
  d: "M1.5 3.75A2.25 2.25 0 013.75 1.5h4.5a2.25 2.25 0 012.25 2.25v4.5a2.25 2.25 0 01-2.25 2.25h-4.5A2.25 2.25 0 011.5 8.25v-4.5z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeWidth: "1.15",
  d: "M12.75 7.5h1.5a2.25 2.25 0 012.25 2.25v4.5a2.25 2.25 0 01-2.25 2.25h-4.5a2.25 2.25 0 01-2.25-2.25v-1.5"
}));